
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PoliticaCookies() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Política de Cookies
            </h1>
            <p className="text-xl text-gray-600">
              Información sobre el uso de cookies en nuestro sitio web
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <div className="bg-gray-50 rounded-lg p-8 mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                ¿Qué son las cookies?
              </h2>
              <p className="text-gray-700 mb-4">
                Las cookies son pequeños archivos de datos que se almacenan en su dispositivo cuando visita un sitio web. 
                Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente, así como para 
                proporcionar información a los propietarios del sitio.
              </p>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Tipos de cookies que utilizamos
              </h2>
              
              <div className="grid gap-6">
                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-settings-3-line text-[#51b038] mr-2"></i>
                    Cookies técnicas (necesarias)
                  </h3>
                  <p className="text-gray-700">
                    Estas cookies son esenciales para el funcionamiento del sitio web y no se pueden desactivar. 
                    Incluyen cookies de sesión, autenticación y preferencias de usuario básicas.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-bar-chart-line text-[#51b038] mr-2"></i>
                    Cookies analíticas
                  </h3>
                  <p className="text-gray-700">
                    Nos ayudan a entender cómo los visitantes interactúan con el sitio web, recopilando y 
                    reportando información de forma anónima.
                  </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center">
                    <i className="ri-user-settings-line text-[#51b038] mr-2"></i>
                    Cookies de personalización
                  </h3>
                  <p className="text-gray-700">
                    Permiten que el sitio web recuerde información que cambia la forma en que se comporta 
                    o se ve, como su idioma preferido o la región en la que se encuentra.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Cookies de terceros
              </h2>
              <div className="bg-blue-50 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Nuestro sitio web puede utilizar cookies de terceros para los siguientes servicios:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li><strong>Google Analytics:</strong> Para análisis de tráfico web</li>
                  <li><strong>WhatsApp:</strong> Para el botón de contacto directo</li>
                  <li><strong>Mapas de Google:</strong> Para mostrar ubicaciones</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Gestión de cookies
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Puede controlar y/o eliminar las cookies como desee. Para obtener más información, 
                  consulte <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" 
                  className="text-[#51b038] hover:underline cursor-pointer">aboutcookies.org</a>.
                </p>
                <p className="text-gray-700 mb-4">
                  Puede eliminar todas las cookies que ya están en su computadora y puede configurar 
                  la mayoría de los navegadores para evitar que se almacenen.
                </p>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                  <p className="text-sm text-yellow-800">
                    <strong>Nota:</strong> Si desactiva las cookies, algunas funcionalidades del sitio web 
                    pueden no funcionar correctamente.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Consentimiento
              </h2>
              <div className="bg-green-50 rounded-lg p-6">
                <p className="text-gray-700">
                  Al utilizar nuestro sitio web, usted acepta el uso de cookies de acuerdo con esta política. 
                  Si no está de acuerdo con el uso de cookies, debe ajustar la configuración de su navegador 
                  en consecuencia o abstenerse de usar el sitio web.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Contacto
              </h2>
              <div className="border border-gray-200 rounded-lg p-6">
                <p className="text-gray-700 mb-4">
                  Si tiene alguna pregunta sobre esta Política de Cookies, puede contactarnos:
                </p>
                <div className="space-y-2 text-gray-700">
                  <p className="flex items-center">
                    <i className="ri-mail-line text-[#51b038] mr-2"></i>
                    <strong>Email:</strong> info@pintolot.com.es
                  </p>
                  <p className="flex items-center">
                    <i className="ri-phone-line text-[#51b038] mr-2"></i>
                    <strong>Teléfono:</strong> 609 93 65 90
                  </p>
                  <p className="flex items-center">
                    <i className="ri-map-pin-line text-[#51b038] mr-2"></i>
                    <strong>Dirección:</strong> Olot, Girona, España
                  </p>
                </div>
              </div>
            </section>

            <div className="text-center mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Última actualización: Diciembre 2024
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
